module.exports = __webpack_public_path__ + "img/Top_Fees_Billed_Paid.e39dbe19.jpeg";